/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StatusTooltip/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function StatusTooltip({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar/FilterByStatus/ClosedStatusFilter/StatusTooltip",
  flowNo,
  flowContent
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={flowNo}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowContent}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}